import { useEffect, useState } from "react";
import { Slides } from "@/components/platform/DirectoryAdmin";
import { AdminHeader } from "@/components/platform/AdminHeader";
import { api } from "@/lib/api";

const src = (u) => (u?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export function EditorSlider() {
  const [paid, setPaid] = useState([]);
  useEffect(() => { api.get("/asv/admin/ads/campaigns").then((r) => setPaid(r.data.campaigns.filter((c) => c.type === "slider" && ["running", "scheduled", "pending_approval"].includes(c.live_status)))).catch(() => {}); }, []);
  return (
    <div className="space-y-4" data-testid="editor-slider">
      <AdminHeader title="Home slider" sub="Your slides show on the home page, mixed in turn with paid vendor slider ads." />
      <Slides />
      <div className="card-surface space-y-3 p-5" data-testid="editor-paid-slides">
        <div><p className="font-semibold text-white">Paid vendor slides</p><p className="text-xs text-slate-500">Approve or reject these in Advertising → Campaigns.</p></div>
        <div className="grid gap-3 sm:grid-cols-3">{paid.map((c) => (
          <div key={c.id} className="overflow-hidden rounded-xl border border-slate-800" data-testid={`paid-slide-${c.id}`}>
            {c.image && <img src={src(c.image)} alt={c.title} className="h-24 w-full object-cover" />}
            <div className="p-2 text-xs text-slate-300"><p className="truncate font-semibold">{c.title}</p><p className="text-slate-500">{c.vendor_name} · {c.start} to {c.end} · {c.live_status.replace("_", " ")}</p></div>
          </div>))}</div>
        {!paid.length && <p className="text-sm text-slate-500">No paid slides running or waiting.</p>}
      </div>
    </div>
  );
}
